// 048: записи хода работы. Вычисляемая колонка не является редактируемым полем пункта.
import { z } from '../kernel/zod.ts';
import { DateSchema, IdSchema, TimestampSchema } from '../kernel/common.ts';

export const PROGRESS_TEXT_MAX = 2000;
export const PROGRESS_BATCH_MAX = 500;
export const progressChannels = ['protocol', 'my', 'letter'] as const;
export const ProgressChannelSchema = z.enum(progressChannels);
export type ProgressChannel = z.infer<typeof ProgressChannelSchema>;
const ProgressTextSchema = z
  .string()
  .max(PROGRESS_TEXT_MAX)
  .refine((text) => text.trim().length > 0, 'Напишите, что сделано')
  .refine(
    (text) =>
      [...text].every((c) => {
        const n = c.charCodeAt(0);
        return (n >= 32 && n !== 127) || n === 9 || n === 10 || n === 13;
      }),
    'Управляющий знак в записи',
  );
export const ProgressInputSchema = z.strictObject({
  id: IdSchema,
  itemId: IdSchema,
  eventDate: DateSchema,
  text: ProgressTextSchema,
  reportedById: IdSchema.nullable().optional(),
});
export const ProgressEditInputSchema = z.strictObject({
  itemId: IdSchema,
  progressId: IdSchema,
  progressRevision: z.number().int().min(1),
  eventDate: DateSchema,
  text: ProgressTextSchema,
  reportedById: IdSchema.nullable().optional(),
});
export const ProgressRefSchema = z.strictObject({
  itemId: IdSchema,
  progressId: IdSchema,
  progressRevision: z.number().int().min(1),
});
export const ProgressEntrySchema = z.object({
  id: IdSchema,
  itemId: IdSchema,
  eventDate: DateSchema,
  text: z.string(),
  author: z.object({ userId: IdSchema, name: z.string() }),
  reportedBy: z.object({ id: IdSchema, name: z.string() }).nullable(),
  publishedAt: TimestampSchema,
  channel: ProgressChannelSchema,
  createdRevision: z.number().int().min(1),
  updatedRevision: z.number().int().min(1),
  editedAt: TimestampSchema.nullable(),
  archivedAt: TimestampSchema.nullable(),
});
export type ProgressEntry = z.infer<typeof ProgressEntrySchema>;
